import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { useCountdown } from '../hooks/useCountdown';
export function ScarcitySection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="py-10 relative overflow-hidden bg-background-dark border-y border-card-border-dark" data-id="element-281">
      <div className="absolute inset-0 bg-gradient-to-b from-urgency/5 to-transparent pointer-events-none" data-id="element-282" />

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-283">
        <FadeIn className="text-center" data-id="element-284">
          <h2 className="text-xl md:text-2xl font-bold text-white uppercase tracking-wider mb-8" data-id="element-285">
            ⏰ EL PRECIO PROMOCIONAL TERMINA EN:
          </h2>

          <div className="flex justify-center items-center gap-4 md:gap-8 mb-8" data-id="element-286">
            <div className="flex flex-col items-center" data-id="element-287">
              <div className="text-5xl md:text-7xl font-black text-urgency font-heading tabular-nums tracking-tight animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-288">
                {hours}
              </div>
              <span className="text-xs md:text-sm text-white font-medium mt-2 tracking-widest notranslate" translate="no" data-id="element-289">
                HS
              </span>
            </div>
            <div className="text-4xl md:text-6xl font-black text-urgency/50 pb-6" data-id="element-290">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-291">
              <div className="text-5xl md:text-7xl font-black text-urgency font-heading tabular-nums tracking-tight animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-292">
                {minutes}
              </div>
              <span className="text-xs md:text-sm text-white font-medium mt-2 tracking-widest notranslate" translate="no" data-id="element-293">
                MIN
              </span>
            </div>
            <div className="text-4xl md:text-6xl font-black text-urgency/50 pb-6" data-id="element-294">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-295">
              <div className="text-5xl md:text-7xl font-black text-urgency font-heading tabular-nums tracking-tight animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-296">
                {seconds}
              </div>
              <span className="text-xs md:text-sm text-white font-medium mt-2 tracking-widest notranslate" translate="no" data-id="element-297">
                SEG
              </span>
            </div>
          </div>

          <p className="text-xl md:text-2xl font-bold text-white mb-10" data-id="element-298">
            Después sube el precio y no vuelve a bajar.
          </p>

          <div className="max-w-lg mx-auto" data-id="element-299">
            <div className="flex justify-between items-center mb-2" data-id="element-300">
              <div className="flex items-center gap-2" data-id="element-301">
                <span className="w-2.5 h-2.5 rounded-full bg-primary animate-pulse" data-id="element-302" />
                <span className="text-primary font-medium text-sm" data-id="element-303">
                  Cupos al precio promocional
                </span>
              </div>
              <span className="text-white font-bold text-sm" data-id="element-304">Quedan pocos</span>
            </div>

            <div className="h-3 w-full bg-card-border-dark rounded-full overflow-hidden mb-2" data-id="element-305">
              <div className="h-full bg-primary rounded-full" style={{
              width: '65%'
            }} data-id="element-306" />
            </div>

            <div className="text-right" data-id="element-307">
              <span className="text-gray-400 text-xs" data-id="element-308">
                13 de 20 cupos tomados hoy
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}